import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './HamburgerMenu.css';

export type MenuOption = 'dashboard' | 'quiz_true_false' | 'quiz_multiple_choice' | 'questions' | 'study_bank' | 'skill_sheets';

interface HamburgerMenuProps {
    onOptionSelect: (option: MenuOption) => void;
    activeOption?: MenuOption; // Made optional since it's determined internally now
    trueFalseCount: number;
    multipleChoiceCount: number;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
    onOptionSelect,
    activeOption,
    trueFalseCount,
    multipleChoiceCount
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option: MenuOption) => {
        switch (option) {
            case 'dashboard':
                navigate('/');
                break;
            case 'quiz_true_false':
                // Note: This will need to be updated to include book context
                // For now, redirect to dashboard where user can select book
                navigate('/');
                break;
            case 'quiz_multiple_choice':
                // Note: This will need to be updated to include book context
                // For now, redirect to dashboard where user can select book
                navigate('/');
                break;
            case 'questions':
                // Note: This will need to be updated to include book context
                // For now, redirect to dashboard where user can select book
                navigate('/');
                break;
            case 'study_bank':
                navigate('/study-bank');
                break;
            case 'skill_sheets':
                navigate('/skill-sheets');
                break;
            default:
                onOptionSelect(option);
        }
        setIsOpen(false);
    };

    // Determine active option based on current location
    const getActiveOption = (): MenuOption => {
        if (location.pathname === '/') return 'dashboard';
        if (location.pathname === '/study-bank') return 'study_bank';
        if (location.pathname.includes('/questions')) return 'questions';
        if (location.pathname.startsWith('/skill-sheets')) return 'skill_sheets';
        if (location.pathname.includes('/quiz/')) return 'quiz_true_false';
        return 'dashboard';
    };

    const currentActiveOption = getActiveOption();

    return (
        <div className="hamburger-menu">
            <button className="hamburger-button" onClick={toggleMenu}>
                <svg className="hamburger-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </button>

            <div className={`menu-overlay ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="menu-content" onClick={(e) => e.stopPropagation()}>
                    <div className="menu-header">
                        <h1 className="menu-title">🔥 Firefighting Practice</h1>
                        <p className="menu-subtitle">Study and quiz yourself on firefighting knowledge</p>
                    </div>

                    <button
                        className={`menu-option ${currentActiveOption === 'dashboard' ? 'active' : ''}`}
                        onClick={() => handleOptionClick('dashboard')}
                    >
                        <span className="menu-option-text">🏠 Dashboard</span>
                        <span className="menu-option-count">📊</span>
                    </button>

                    <button
                        className={`menu-option ${currentActiveOption === 'quiz_true_false' ? 'active' : ''}`}
                        onClick={() => handleOptionClick('quiz_true_false')}
                    >
                        <span className="menu-option-text">📝 Take Quiz</span>
                        <span className="menu-option-count">{trueFalseCount + multipleChoiceCount}</span>
                    </button>

                    <button
                        className={`menu-option ${currentActiveOption === 'questions' ? 'active' : ''}`}
                        onClick={() => handleOptionClick('questions')}
                    >
                        <span className="menu-option-text">🔍 Browse Questions</span>
                        <span className="menu-option-count">{trueFalseCount + multipleChoiceCount}</span>
                    </button>

                    <button
                        className={`menu-option ${currentActiveOption === 'study_bank' ? 'active' : ''}`}
                        onClick={() => handleOptionClick('study_bank')}
                    >
                        <span className="menu-option-text">📚 Study Bank</span>
                        <span className="menu-option-count">∞</span>
                    </button>

                    <button
                        className={`menu-option ${currentActiveOption === 'skill_sheets' ? 'active' : ''}`}
                        onClick={() => handleOptionClick('skill_sheets')}
                    >
                        <span className="menu-option-text">🧑‍🚒 Skill Sheets</span>
                        <span className="menu-option-count">59</span>
                    </button>

                </div>
            </div>
        </div>
    );
};

export default HamburgerMenu; 